import React from 'react';
import PropTypes from 'prop-types';
import { Progress } from 'antd';
import investorSurvey from '../investorSurveyData';
import './styles.less';

const InvestorProfileProgress = ({ currentQuestionIndex }) => {
  const questionsCount = investorSurvey.questions.length;

  const getProgressLabel = () => `${currentQuestionIndex + 1} de ${questionsCount}`;

  const currentPercent = Math.min(
    Math.ceil((100 * (currentQuestionIndex + 1)) / questionsCount),
    99.999
  );

  return (
    <Progress
      type="line"
      format={getProgressLabel}
      percent={currentPercent}
      className="investor-profile-progress"
    />
  );
};

InvestorProfileProgress.propTypes = {
  currentQuestionIndex: PropTypes.number.isRequired,
};

export default InvestorProfileProgress;
